var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"show-image",attrs:{"src":_vm.imageUrl,"alt":"展示图片"}}),_c('p',{staticClass:"scan-tip"},[_vm._v("请保存二维码或者长按扫一扫完成支付")])])
}
var staticRenderFns = []

export { render, staticRenderFns }